module.exports = "/_next/static/images/Compliance-62f58544a36e75a83e507bfc1429689d.webp";